import { render } from "./GameOver.vue?vue&type=template&id=5579e14c"
import script from "./GameOver.vue?vue&type=script&lang=js"
export * from "./GameOver.vue?vue&type=script&lang=js"

import "./GameOver.vue?vue&type=style&index=0&id=5579e14c&lang=css"

import exportComponent from "/tmp/build_4e4571bb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__